import React, { useRef } from "react";
import {getWeeks, renderPrintFooter} from "../../utils";
import Input from "../Input";
import {executeQuery} from "../../requests/executeQuery";
import {manageData} from "../../requests/CRUD";
import {BucketsColumnsModel} from "./bucketsColumnsModel";
import {columns, averageColumns} from "./columns";
import {OVERFLOW_TABLE_WIDTH} from '../../consts/tables';
import {BUCKETS} from "../../consts/tables";
import './Buckets.scss';
import Alert from "../Alert";
import {Link} from "react-router";
import {stringUStoISO} from "../../date-converter";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import svgSortDesc from "../../svgs/arrow-down.svg";
import { ApolloConsumer } from '@apollo/client';
import filter from "../../filter";
import { GET_STRIVE_BUCKETS } from "../Graphql/Queries/BucketsQuery";


import { UPDATE_BUCKET } from "../Graphql/Mutations/BucketsMutation";
import { GetOldResponse } from "../ResponseConversion/GetOldResponse";
import { fetchData, mutateData } from "../Service/graphQlService";

const cloneDeep = require('lodash.clonedeep');
const tableHeaderHeight = 48;
const limit = 50;
export default class Buckets extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef =  React.createRef()
        this.tableKeyRef =  React.createRef()
        this.state = {
            rows: {},
            width: 1400,
            height: tableHeaderHeight,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            isPrint: false,
            printBackground: '',
            sortOrder:{sortKey:'',order:'asc'}
        };
        this.client = null
      
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.updateTableWidth = this.updateTableWidth.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        if (this.client) {
			this.fetch(this.props.location.query);
		}
        this.updateTableWidth();
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.addEventListener('resize', this.updateTableWidth);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateTableWidth);
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    static buildData(data, year) {
        const rows = {};
        data.map(row => {
            rows[row.AGENT_LAST_NAME + ' ' + row.AGENT_FIRST_NAME] = new BucketsColumnsModel(row, year);
        });
        return rows;
    }


    fetch(q) {
        // this.setState({ isBusy: true });
        const token = localStorage.getItem('authToken');
        // executeQuery({queryName: STRIVE_BUCKETS})
        // if (this.client) {
        //     this.client.query({
        //         query: GET_STRIKE_BUCKET, variables: { queryName:STRIVE_BUCKETS }, fetchPolicy: "no-cache",
        //         // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
        //         context: {
        //             headers: {
        //                 authorization: `Bearer ${token}`, // Bearer token added here
        //             },
        //         },
        //     })
        if (this.client) {
            const query = { ...q };
            const options = filter(query, 'sellers');
            options.param.limit = limit;
            options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;
            var pageParams = {
                page: query.page ? Number(query.page) : 1,
                pageSize: limit
            }
            
            // this.client.query({
            //     query: GET_STRIVE_BUCKETS, variables: { pageOptions: pageParams }, fetchPolicy: "no-cache",
            //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },

            fetchData(GET_STRIVE_BUCKETS,{ pageOptions: pageParams }
            ).then(res => {
                // const getBucketsData = convertKeysToUppercase(res.data.getBuckets)
                var newRes = GetOldResponse(res);
                const {responses} = newRes
                if (responses && responses[0].success && Array.isArray(responses[0].data) && responses[0].data.length) {
                const year = new Date().getFullYear();                
                var rows = Buckets.buildData(responses[0].data, year);                            
                rows = Object.fromEntries(Object.entries(rows).sort((a, b) => {
                    const lastNameComaprision = a[1].AGENT_LAST_NAME ? a[1].AGENT_LAST_NAME.localeCompare(b[1].AGENT_LAST_NAME) : 0;
                    if(lastNameComaprision === 0){
                        return a[1].AGENT_FULL_NAME.localeCompare(b[1].AGENT_FULL_NAME);
                    }
                    return lastNameComaprision;
                }));

                this.setState({rows, original: cloneDeep(rows)}, () => {
                    const headerHeight = 40;
                    const headDetailsHeight = this.props.isSuper ? 163 : 116;
                    const bottomSpaceHeight = 30;
                    let height = window.innerHeight - headerHeight - headDetailsHeight - bottomSpaceHeight;
                    if (height > this.tableRef.current.clientHeight && this.tableRef.current.clientHeight >= tableHeaderHeight) {
                        height = this.tableRef.current.clientHeight;
                    }
                    this.setState({height});
                });
            }
        });
    }
    }

    handleChange(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        const colKey = name[1];
        if (columnType === 'date') {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9/]/g, '') : '';
        } else {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9.]/g, '') : '';
            rows[rowKey][`AVE_${colKey}`] = rows[rowKey][colKey] ? parseFloat(rows[rowKey][colKey] / rows[rowKey].WEEKS).toFixed(2) : 0;
        }
        this.setState({rows});
    }

    handleBlur(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        rows[rowKey].WEEKS = getWeeks(new Date(rows[rowKey].START_DATE), new Date());
        if (columnType === 'date')
            averageColumns.map(column => {
                const key = column.key.replace('AVE_', '');
                rows[rowKey][column.key] = rows[rowKey][key] ? parseFloat(rows[rowKey][key] / rows[rowKey].WEEKS).toFixed(2) : 0;
            });
        this.setState({rows});
    }

   async handleSave() {
        if (this.state.isBusy) return;

        let rows = cloneDeep(this.state.rows);
        const columnsToSave = columns.filter(column => column.editable);
        const data = [];
        let index = 0;
       
        // Save only if updates exist
        Object.keys(rows).forEach(agent => {
            data[index] = {};
            columnsToSave.forEach(column => {
                if (column.type === 'date' && rows[agent][column.key])
                    rows[agent][column.key] = stringUStoISO(rows[agent][column.key]);
                if (rows[agent][column.key] !== this.state.original[agent][column.key])
                    data[index][column.key] = rows[agent][column.key];
            });

            if (Object.keys(data[index]).length)
                data[index++].AGENT_ID = rows[agent].AGENT_ID;
            else
                data.pop();
        });

        // No changes detected, nothing to do
        if (!data.length) {
            this.setState({
                isBusy: null,
                error: null,
                success: 'No data to update',
            });
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });
        // let obj = {}
        // const transformedData = data.map(entry => ({
        //     start_date: entry.START_DATE,
        //     agent_id: entry.AGENT_ID.toString().trim() // Convert agent_id to string and trim whitespace
        // }));
        // manageData({tableCode: BUCKETS, data})
         // .then(res => {
        //     if (res && res.success) {
        //         this.setState({
        //             isBusy: null,
        //             success: 'Saved',
        //             original: cloneDeep(rows),
        //         })
        //     } else {
        //         this.setState({
        //             isBusy: null,
        //             error: res && res.message ? res.message : 'Unspecified error',
        //         });
        //     }
        // });
        const token = localStorage.getItem('authToken');
        if (this.client) {
            try {
                // const res = await this.client.mutate({
                //     mutation: UPDATE_BUCKET,
                //     variables: {input:data},
                //     fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`,
                //         },
                //     },
                //     // refetchQueries: [{ query: GET_BUYERS, variables: { pageOptions: pageParams } }],
                // });
                if(data && data.length>1){
                    data.map(item=>{
                        if(item && item.ON_PHONES){
                            item.START_DATE = item.ON_PHONES
                            delete item.ON_PHONES
                        }
                    })
                }
                const res = await mutateData(UPDATE_BUCKET, {input:data});
                if (res && res.data.createOrUpdateBucket.success) {
                    this.setState({
                                    isBusy: null,
                                    success: 'Saved',
                                    original: cloneDeep(rows),
                                })
                }
            } catch (error) {
                this.setState({
                                isBusy: null,
                                error: res && res.data.createOrUpdateBucket.message ? res.data.createOrUpdateBucket.message : 'Unspecified error',
                            });
            }
        }
        // .then(res => {
        //     if (res && res.success) {
        //         this.setState({
        //             isBusy: null,
        //             success: 'Saved',
        //             original: cloneDeep(rows),
        //         })
        //     } else {
        //         this.setState({
        //             isBusy: null,
        //             error: res && res.message ? res.message : 'Unspecified error',
        //         });
        //     }
        // });
    }

    updateTableWidth() {
        this.setState({width: window.innerWidth - OVERFLOW_TABLE_WIDTH});
    }

    handleKeyDown(event, key, rowindex, rows, cols) {
        event.stopPropagation();
        const keys = Object.keys(rows);
        const id = event.target.getAttribute("id");

        let updatedId = id.substr(0, id.indexOf("+"));
        const name = event.target.getAttribute("data-name");
        const nameIndex = parseInt(event.target.getAttribute("data-index"));
        let rowid;
        let upkey;
        let upid;
        let nextEditableIndex = 0;
        switch (event.key) {
            case "ArrowUp":
            case 'Enter':
            case "ArrowDown":
                rowid = event.key == 'ArrowUp' ? rowindex - 1 : rowindex + 1;
                upkey = keys[rowid];
                upid = updatedId + "+" + rowid;
                upid = upid.replace(key, upkey);
                document.getElementById(upid).focus();
                break;
            case "ArrowLeft":
            case "ArrowRight":
                const keydownstart = event.target.selectionStart;
                const value = event.target.value;
                if (event.key === 'ArrowRight') {

                    if (value.length > keydownstart && keydownstart != value.length) {
                        return
                    }
                    for (let i = nameIndex + 1; i < cols.length; i++) {
                        if (cols[i].editable) {
                            nextEditableIndex = i;
                            break;
                        }
                    }
                } else {
                    if (value.length >= keydownstart && keydownstart != 0) {
                        return
                    }
                    for (let i = nameIndex - 1; i < cols.length; i--) {
                        if (cols[i].editable) {
                            nextEditableIndex = i;
                            break;
                        }
                    }
                }
                upid = updatedId + "+" + rowindex;
                upid = upid.replace(name, cols[nextEditableIndex].key);
                document.getElementById(upid).focus();
                break;
            default: break;
        }
    }

    sortBy(column) {
        const rows = [];
        const rowsData = cloneDeep(this.state.rows);
        
        const { sortKey, order } = this.state.sortOrder;
        let colOrder = order
        if(column.key == sortKey) {
            colOrder = colOrder == 'asc' ? 'dsc' : 'asc';
        } else {
            colOrder = 'asc';
        }
        let _rows = [];
        Object.keys(rowsData).forEach(function (key) {
            const obj = {
                AGENT_FULL_NAME: rowsData[key].AGENT_FULL_NAME,
                AGENT_ID: rowsData[key].AGENT_ID,
                AGENT_LAST_NAME: rowsData[key].AGENT_LAST_NAME,
                AGENT_NAME: key,
                AVE_CALLS: rowsData[key].AVE_CALLS,
                AVE_MEETINGS: rowsData[key].AVE_MEETINGS,
                AVE_PROPOSALS: rowsData[key].AVE_PROPOSALS,
                CALLS: rowsData[key].CALLS,
                MEETINGS: rowsData[key].MEETINGS,
                PROPOSALS: rowsData[key].PROPOSALS,
                START_DATE: rowsData[key].START_DATE,
                ON_PHONES: rowsData[key].ON_PHONES,
                TOTAL_CLOSED: rowsData[key].TOTAL_CLOSED,
                TOTAL_GROSS_FEE: rowsData[key].TOTAL_GROSS_FEE,
                TOTAL_LISTINGS: rowsData[key].TOTAL_LISTINGS,
                TOTAL_UC: rowsData[key].TOTAL_UC,
                WEEKS: rowsData[key].WEEKS,
            }

           
            rows.push(obj);
        })
        if (sortKey !== column.key || colOrder === 'asc') {
            _rows = rows.sort((a, b) => {
                let avalue = a[column.key];
                let bvalue = b[column.key];
                if (column.type === 'date') {
                    avalue = new Date(a[column.key]).valueOf();
                    bvalue = new Date(b[column.key]).valueOf();
                }
                else if(avalue != null && typeof(avalue)== 'string' && avalue.indexOf("$")!=-1){
                    avalue = parseInt(a[column.key].trim().substr(1).replaceAll(",",""));
                    bvalue = parseInt(b[column.key].trim().substr(1).replaceAll(",",""));
                }
                return avalue - bvalue;
            });
        }
        else {
            _rows = rows.sort((a, b) => {
                let avalue = a[column.key];
                let bvalue = b[column.key];
                if (column.type === 'date') {
                    avalue = new Date(a[column.key]).valueOf();
                    bvalue = new Date(b[column.key]).valueOf();
                }
                else if(avalue != null && typeof(avalue)== 'string' && avalue.indexOf("$")!=-1){
                    avalue = parseInt(a[column.key].trim().substr(1).replaceAll(",",""));
                    bvalue = parseInt(b[column.key].trim().substr(1).replaceAll(",",""));
                }
                return bvalue - avalue
            });
        }
        const  data = cloneDeep(rows)
        const copyrows={};
         data.forEach(row => {
            copyrows[row.AGENT_NAME] = row;
          
        });
        
        const sortOrder = {
            sortKey: column.key,
            order: colOrder
        }
        this.setState({ rows: copyrows, sortOrder })
    }   
    renderTable({ rows, cols, isPrintTable }) {
        
        return (
            <table className='table' ref={isPrintTable ? null : this.tableRef}>
                <thead>
                    <tr>
                        {
                            cols.map((column, index) => {
                                const { sortKey, order } = this.state.sortOrder;
                                if (index === 0)
                                    return <th key={index} className="Buckets_th border_top border_left" id='Buckets_first_cell'>{column.label}</th>;
                                return <th key={index} className="Buckets_th border_top">
                                    <div class="SortTable_th_name active">
                                        <button className="btn-text" onClick={(e)=> 
                                            this.sortBy(column)}> 
                                            <div
                                                                    className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                                                        <span
                                                                            className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortAsc}/>
                                                                        </span>
                                                                        {column.label}
                                                                    <span
                                                                        className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortDesc}/>
                                                                        </span>
                                                                </div>
                                            
                                        </button>
                                                    </div>
                                                    </th>
                            })
                        }
                    </tr>
                </thead>
                <tbody ref={this.tableKeyRef}>
                    {
                        Object.keys(rows).map((key, rowindex) => {
                            if (!rows[key]) return;
                            return (
                                
                                <tr key={key} className="Buckets_tr" onKeyDown={(e) => this.tableKeyRef && this.handleKeyDown(e, key, rowindex, rows, cols)}>
                                    {
                                        cols.map((column, index) => {
                                            if (index === 0)
                                                return (
                                                    <th key={key + '-' + index} className='Buckets_th agents border_left'>
                                                        <Link to={{ pathname: `${arc.path.base}buckets/${rows[key].AGENT_ID}`, state: { id: rows[key].AGENT_ID, name: rows[key].AGENT_FULL_NAME, state: { fromListUrl: window.location.pathname + window.location.search } } }}>{rows[key].AGENT_FULL_NAME}</Link>
                                                    </th>
                                                );
                                            if (this.props.isSuper && column.editable)
                                                return (
                                                    <td key={key + '-' + index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                        <Input data-index={index} data-name={column.key} theme={column.hasHighlight ? 'gray_without_border' : 'without_border'} className='Buckets_td' id={!isPrintTable ? key + '-' + column.key + '+' + rowindex : null} type='text' pattern={column.type === 'number' ? '^[0-9]*$' : ''} name={key + '-' + column.key} value={rows[key][column.key]} displayZero={true} onChange={(e) => this.handleChange(e, column.type)} onBlur={(e) => this.handleBlur(e, column.type)} tabIndex="0" />
                                                    </td>
                                                );
                                            return (
                                                <td key={key + '-' + index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                    {rows[key][column.key]} 
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        );
    }

    renderPrintPage({rows, cols, date, isPrint, printBackground}) {
        return (
            <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                <div className='Buckets_head_left'>
                    <h3 className='Buckets_h3'>STRIVE Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                </div>
                <div className='table-print-container'>
                    {this.renderTable({rows, cols, isPrintTable: true})}
                </div>
                {renderPrintFooter(isPrint)}
            </div>
        )
    }

    render() {
        const {rows, isPrint, printBackground} = this.state;
        const isSuper = this.props.isSuper;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();
        const { isPrintTable } = this.props;
        return (
            <ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
						this.fetch(this.props.location.query);
					}
					return (
            <div className='Buckets'>
                { this.state.success ? <Alert type='success' position='absolute'>{this.state.success}</Alert> : null }
                { this.state.error ? <Alert type='error' position='absolute'>{this.state.error}</Alert> : null }

                {this.renderPrintPage({rows, cols: columns, date, isPrint, printBackground})}
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>

                <div className='Buckets_head'>
                    <h3 className='Buckets_h3'>STRIVE Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                    {isSuper ? <button className='Buckets_save' data-busy={this.state.isBusy} onClick={this.handleSave}>Save</button> : null }
                </div>
                <div className='Buckets_scroll_container' style={{width: this.state.width, height: this.state.height}}>
                    {this.renderTable({rows, cols: columns})}
                </div>
            </div>
            	)
            }}

        </ApolloConsumer>
        )
    }
}